import { useSelector } from 'react-redux';

export default () => {
  const isLoginRequiredModalOpen = useSelector((state) => state.cmmeReducer.isLoginRequiredModalOpen);
  const isSaveProjectModalOpen = useSelector((state) => state.cmmeReducer.isSaveProjectModalOpen);
  const isVariantColorModalOpen = useSelector((state) => state.core.isVariantColorModalOpen);
  const isShortcutModalOpen = useSelector((state) => state.cmmeReducer.isShortcutModalOpen);

  return isLoginRequiredModalOpen || isSaveProjectModalOpen || isVariantColorModalOpen || isShortcutModalOpen;
};
